module.exports = __webpack_public_path__ + "img/icon_coupon.51fed8b8.png";